import FaqCluster from "./faq/FaqCluster";
import FaqDetail from "./faq/FaqDetail";
import FaqTopic from "./faq/FaqTopic";
import NewsEvents from "./newsEvents";
import NewsEventsDetail from "./newsEvents/newsEventsDetail";
import SearchPage from "./search";
import SurveyNPS from "./surveies/surveyNPS";

// TODO: remove any
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const templates: Record<string, any> = {
  faqDetail: FaqDetail,
  faqTopic: FaqTopic,
  faqCluster: FaqCluster,
  newsEvents: NewsEvents,
  newsEventsDetail: NewsEventsDetail,
  searchPage: SearchPage,
  surveyNPS: SurveyNPS,
};

export default templates;
